import React from 'react';
import {Text, TouchableOpacity, View} from 'react-native';
import styles from './PrimaryButton.style';
import LottieView from 'src/imports/Lottie';
import SVG from '../../imports/svg';

const PrimaryButton = props => {
  const {
    isLoading,
    title,
    containerStyle,
    textStyle,
    isLight = false,
    icon,
    loadingStyle,
    children,
    isDisabled = false,
    error = '',
  } = props;

  return (
    <TouchableOpacity
      style={[
        styles.container,
        containerStyle,
        isDisabled && {backgroundColor: '#ACACAC'},
        (error === 'HelmetLockIsNotLocked') && {
          backgroundColor: '#F74B4A',
        },
      ]}
      disabled={isLoading || isDisabled}
      {...props}>
      {isLoading && (
        <LottieView
          autoPlay
          loop={true}
          source={
            isLight
              ? require('../../assets/animations/trip_loading_secondary.json')
              : require('../../assets/animations/trip_loading_white.json')
          }
          style={[styles.loading, loadingStyle]}
        />
      )}
      {!!icon && (
        <View style={styles.icon}>
          <SVG name={icon} height={20} width={20} />
        </View>
      )}
      {title && (
        <Text
          style={[
            styles.title,
            textStyle,
            {
              opacity: isLoading ? 0 : 1,
            },
          ]}>
          {title}
        </Text>
      )}
      {children && children}
    </TouchableOpacity>
  );
};
export default PrimaryButton;
